import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const TemperatureHistoryPage = lazy(() => import("./TemperatureHistoryPage"));

const TemperatureHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <TemperatureHistoryPage />
    </Suspense>
  );
};

export default TemperatureHistoryPageLazy;
